import { useQuery } from "@tanstack/react-query";

import { fetchUsageStats } from "@/lib/api";

export function useUsageStats(days = 14, mine = true) {
  return useQuery({
    queryKey: ["usage-stats", days, mine],
    queryFn: () => fetchUsageStats(days, mine),
    staleTime: 30_000,
    refetchInterval: 60_000,
  });
}
